import { INBOX_SPLITTER_WIDTH_PX } from "../inboxLayoutConfig";

function SplitterVisual() {
  return (
    <span
      className="pointer-events-none block h-full w-px shrink-0 rounded-full bg-slate-200 group-hover:bg-teal-400 group-focus-visible:bg-teal-500 dark:bg-slate-600 dark:group-hover:bg-teal-500"
      aria-hidden
    />
  );
}

/**
 * Desktop drag handle for inbox/ticket columns.
 * Must be a direct flex child of the row so it stretches to full height.
 */
export default function ColumnSplitter({ gripProps }) {
  return (
    <div
      className="relative z-10 hidden h-full min-h-0 shrink-0 self-stretch md:flex"
      style={{ width: INBOX_SPLITTER_WIDTH_PX }}
    >
      <div {...gripProps}>
        <SplitterVisual />
      </div>
    </div>
  );
}
